<template>
  <div class="l-content">
    <div class="row">
      <div class="col-xs-16 col-xs-offset-1 col-sm-14 col-sm-offset-2">
        <div class="pillar"  :class="{'pillar--right': alignRight}">
          <div class="pillar-picture">
            <img :src="picture" :alt="alt">
          </div>
          <div class="pillar-card">
            <h3>{{title}}</h3>
            <div class="pillar-stat-container" v-if="stat">
              <span class="pillar-stat c-lightgreen">{{stat}}</span>
              <span class="pillar-stat-unit c-lightgreen">{{statUnit}}</span>
            </div>
            <p class="pillar-content t-darker-grey m-0" v-html="content"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Pillar',
  props: {
    picture: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: false
    },
    alignRight: {
      type: Boolean,
      required: false
    },
    stat: {
      type: String,
      required: false
    },
    statUnit: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../scss/vars';
@import '../scss/mixins';

.pillar {
  position: relative;
  margin-bottom: 20px;
  @include clearfix();
  @media(min-width: $screen-md-min) {
    &.pillar--right {
      .pillar-picture {
        float: right;
      }
      .pillar-card {
        right: inherit;
        left: 0;
      }
    }
  }
  .pillar-picture {
    @media(min-width: $screen-md-min) {
      width: 71%;
      float: left;
    }
    img {
      width: 100%;
      height: auto;
      object-fit: cover;
      box-shadow: 0 18px 28px 0 rgba(0, 0, 0, .04);
    }
  }
  .pillar-card {
    border-radius: 10px;
    background: $white;
    text-align: left;
    width: 90%;
    position: relative;
    top: -20px;
    margin: auto;
    padding: 28px;
    @media(min-width: $screen-md-min) {
      position: absolute;
      right: 0;
      top: 20px;
      width: 50%;
      padding: 40px;
    }
    @media(min-width: $screen-md-min) {
      width: 42.8%;
    }
    h3 {
      color: $green-light;
      margin-bottom: 12px;
      @media(min-width: $screen-md-min) {
        margin-bottom: 12px;
      }
    }
    .pillar-stat {
      font-size: px2rem(42);
      font-weight: 300;
    }
    .pillar-stat-unit {
      font-size: px2rem(15);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pillar.vue